import { render, staticRenderFns } from "./DetailSettingsEdit.vue?vue&type=template&id=3ab7ee43&scoped=true"
import script from "./DetailSettingsEdit.vue?vue&type=script&lang=ts"
export * from "./DetailSettingsEdit.vue?vue&type=script&lang=ts"
import style0 from "./DetailSettingsEdit.vue?vue&type=style&index=0&id=3ab7ee43&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7ee43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab7ee43')) {
      api.createRecord('3ab7ee43', component.options)
    } else {
      api.reload('3ab7ee43', component.options)
    }
    module.hot.accept("./DetailSettingsEdit.vue?vue&type=template&id=3ab7ee43&scoped=true", function () {
      api.rerender('3ab7ee43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/DetailSettingsEdit.vue"
export default component.exports